<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">{{ $t('leaveManagementWorkSeetDetail.pageTitle') }}</h1>
            <ts-breadcrumb :items="[
                { text: $t('toHomePage'), href: '/' },
                {
                    text: $t('leaveManagementWorkSeetDetail.pageTitle'),
                    active: true
                }
            ]" />
        </div>
        <ts-card>
            <ts-card-wrapper>
                <form class="form-horizontal">
                    <div class="row">
                        <div class="col-md-2 form-group">
                            <label>{{ $t('leaveManagementWorkSeetDetail.branchName') }}</label>
                            <div>
                                <a-select v-model="model.branch_id" :options="branchs" showSearch mode="multiple"
                                    :filterOption="(input, option) =>
                                        option.componentOptions.children[0].text
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')"
                                    style="width: 100%">
                                </a-select>
                            </div>
                            <div class="validate" v-if="errors.has('branch_id')">
                                {{ errors.first('branch_id') }}
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="required">{{ $t('leaveManagementWorkSeetDetail.date') }}</label>
                            <div>
                                <ts-date-picker-input format="YYYY" v-model="model.cycle_year"></ts-date-picker-input>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label>{{ $t('leaveManagementWorkSeetDetail.department') }}</label>
                            <div>
                                <a-select v-model="model.department_id" :options="departments"
                                    @change="onChangeDepartments" showSearch mode="multiple" :filterOption="(input, option) =>
                                        option.componentOptions.children[0].text
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        " :maxTagCount="1" :placeholder="$t('all')" style="width: 100%"></a-select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label>{{ $t('leaveManagementWorkSeetDetail.employeeName') }}</label>
                            <a-select v-model="model.staff_id" :options="employees" :showSearch="true" mode="multiple"
                                :filterOption="(input, option) =>
                                    option.componentOptions.children[0].text
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    " :maxTagCount="1" :placeholder="$t('all')" :maxTagTextLength="17"
                                style="width: 100%"></a-select>
                        </div>
                        <div class="mt-4">
                            <ts-button class="btn-block" color="primary" :disabled="loading" :waiting="waiting"
                                @click="preview">{{
                                    $t('preview') }}</ts-button>
                        </div>
                        <div class="mt-4">
                            <ts-button
                class="ml-2 mr-2"
                outline
                color="success"
                :waiting="exporting"
                @click.prevent="exportExcel"
                >{{ $t('excel') }}</ts-button
              >

                        </div>
                    </div>

                </form>
            </ts-card-wrapper>
            <div class="overflow-auto">
                <ts-loading-banner :loading="loading">
                    <ts-table :records="resources" :columnLengths="18" :rowGroup="{
                        field: 'department_name_en',

                    }" class="ts-whitespace-no-wrap">
                        <template v-slot:thead>
                            <thead>
                                <tr>

                                    <th rowspan="2" class="text-center nowrap color-b color-title">{{
                                        $t('leaveManagementWorkSeetDetail.employeeName') }}</th>
                                    <th colspan="5" class="text-center nowrap color-green color-title">{{
                                        $t('leaveManagementWorkSeetDetail.annualLeave') }}</th>
                                    <th colspan="5" class="text-center nowrap color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.specialLeave') }}</th>
                                    <th colspan="5" class="text-center nowrap color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.sickLeave') }}</th>
                                    <th colspan="5" class="text-center nowrap color-red color-title">{{
                                        $t('leaveManagementWorkSeetDetail.unpaidLeave') }}</th>
                                    <th colspan="5" class="text-center nowrap color-blue color-title">{{
                                        $t('leaveManagementWorkSeetDetail.maternityLeave') }}</th>
                                    <th colspan="5" class="text-center nowrap color-blue color-title">{{
                                        $t('leaveManagementWorkSeetDetail.paternityLeave') }}</th>
                                    <th rowspan="2" class="text-center nowrap color-orange color-title">{{
                                        $t('leaveManagementWorkSeetDetail.totalAbsenses') }}</th>
                                    <th rowspan="2" class="text-center nowrap color-title color-b">{{
                                        $t('leaveManagementWorkSeetDetail.lastBalance') }}</th>
                                </tr>
                                <tr>
                                    <th rowspan="2" class="color-green color-title">{{
                                        $t('leaveManagementWorkSeetDetail.carryForward') }}</th>
                                    <th rowspan="2" class="color-green color-title">{{
                                        $t('leaveManagementWorkSeetDetail.entitlement') }}</th>
                                    <th rowspan="2" class="color-green color-title">{{
                                        $t('leaveManagementWorkSeetDetail.adjustment') }}</th>
                                    <th rowspan="2" class="color-green color-title">{{
                                        $t('leaveManagementWorkSeetDetail.used') }}</th>
                                    <th rowspan="2" class="color-green color-title">{{
                                        $t('leaveManagementWorkSeetDetail.balance') }}</th>

                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.carryForward') }}</th>
                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.entitlement') }}</th>
                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.adjustment') }}</th>
                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.used') }}</th>
                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.balance') }}</th>

                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.carryForward') }}</th>
                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.entitlement') }}</th>
                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.adjustment') }}</th>
                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.used') }}</th>
                                    <th rowspan="2" class="color-yeallow color-title">{{
                                        $t('leaveManagementWorkSeetDetail.balance') }}</th>

                                    <th rowspan="2" class="color-red color-title">{{
                                        $t('leaveManagementWorkSeetDetail.carryForward') }}</th>
                                    <th rowspan="2" class="color-red color-title">{{
                                        $t('leaveManagementWorkSeetDetail.entitlement') }}</th>
                                    <th rowspan="2" class="color-red color-title">{{
                                        $t('leaveManagementWorkSeetDetail.adjustment') }}</th>
                                    <th rowspan="2" class="color-red color-title">{{
                                        $t('leaveManagementWorkSeetDetail.used') }}</th>
                                    <th rowspan="2" class="color-red color-title">{{
                                        $t('leaveManagementWorkSeetDetail.balance') }}</th>

                                    <th rowspan="2" class="color-blue color-title">{{
                                        $t('leaveManagementWorkSeetDetail.carryForward') }}</th>
                                    <th rowspan="2" class="color-blue color-title">{{
                                        $t('leaveManagementWorkSeetDetail.entitlement') }}</th>
                                    <th rowspan="2" class="color-blue color-title">{{
                                        $t('leaveManagementWorkSeetDetail.adjustment') }}</th>
                                    <th rowspan="2" class="color-blue color-title">{{
                                        $t('leaveManagementWorkSeetDetail.used') }}</th>
                                    <th rowspan="2" class="color-blue color-title">{{
                                        $t('leaveManagementWorkSeetDetail.balance') }}</th>


                                    <th rowspan="2" class="color-title color-blue">{{
                                        $t('leaveManagementWorkSeetDetail.carryForward') }}</th>
                                    <th rowspan="2" class="color-title color-blue">{{
                                        $t('leaveManagementWorkSeetDetail.entitlement') }}</th>
                                    <th rowspan="2" class="color-title color-blue">{{
                                        $t('leaveManagementWorkSeetDetail.adjustment') }}</th>
                                    <th rowspan="2" class="color-title color-blue">{{
                                        $t('leaveManagementWorkSeetDetail.used') }}</th>
                                    <th rowspan="2" class="color-title color-blue">{{
                                        $t('leaveManagementWorkSeetDetail.balance') }}</th>

                                </tr>
                            </thead>
                        </template>
                        <template v-slot="{ record, index }">
                            <td class="ts-whitespace-no-wrap">{{ record.staff_name_en }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.anl_carry_forward }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.anl_entitle_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.anl_adjustment
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.anl_leave_used
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.anl_leave_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.spl_carry_forward }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.spl_entitle_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.spl_adjustment
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.spl_leave_used
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.spl_leave_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.skl_carry_forward }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.skl_entitle_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.skl_adjustment
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.spl_leave_used
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.spl_leave_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.upl_carry_forward }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.upl_entitle_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.upl_adjustment
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.upl_leave_used
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.upl_leave_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.mtl_carry_forward }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.mtl_entitle_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.mtl_adjustment
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.mtl_leave_used
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.mtl_leave_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.ptl_carry_forward }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.ptl_entitle_balance }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.ptl_adjustment
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{ record.ptl_leave_used
                            }}</td>
                            <td class="ts-whitespace-no-wrap text-center ts-whitespace-no-wrap">{{
                                record.ptl_leave_balance }}</td>

                        </template>
                    </ts-table>
                </ts-loading-banner>
            </div>
            <div class="d-flex justify-content-between align-items-center p-15">
                <ts-total-list v-model="pagination" />
                <ts-pagination v-model="pagination" @navigate="preview"></ts-pagination>
            </div>
        </ts-card>
    </div>
</template>
<script>

import { mapActions, mapState } from 'vuex';
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
    name: 'leaveManagementWorkseetDetail',
    data() {
        return {
            loading: false,
            errors: new Errors(),
            waiting: false,
            fetchDataLoading: false,
            exporting: false,
            branchs: [],
            departments: [],
            employees: [],
            model: {
                branch_id: [],
                department_id: [],
                staff_id: [],
                cycle_year: moment().format('YYYY'),
            }

        }
    },
    created() {
        this.getBranch()
        this.getDepartment()
        this.getEmployee()
    },
    computed: {
        ...mapState('leaveManagementWorkseetDetail', ['resources', 'pagination']),

    },
    methods: {
        ...mapActions('leaveManagementWorkseetDetail', ['getBranch', 'getDepartment', 'getEmployee']),

        getBranch() {
            this.$store
                .dispatch('leaveManagementWorkseetDetail/getBranch', this.model)
                .then(response => {
                    this.branchs = response.data.map(el => ({
                        value: el.branch_id,
                        label: el.branch_name_en
                    }))
                })
        },
        getDepartment() {
            this.$store.dispatch('leaveManagementWorkseetDetail/getDepartment')
                .then(response => {
                    this.departments = response.data.map(el => ({
                        value: el.department_id,
                        label: el.department_name_en
                    }))
                })
        },
        onChangeDepartments() {
            this.model.staff_id = []
            this.getEmployee({
                filter: {
                    department_id: this.model.department_id
                }
            }).then(response => {
                this.employees = response.data.map(el => ({
                    value: el.staff_id,
                    label: el.name_en + '|' + el.name_kh
                }))
            })
        },

        preview(attributes) {
            this.loading = true
            this.errors = new Errors()
            this.$store
                .dispatch(
                    'leaveManagementWorkseetDetail/fetchData',
                    Object.assign(
                        {},
                        this.model,
                        {
                            branch_id: this.model.branch_id,
                            department_id: this.model.department_id,
                            cycle_year: this.model.cycle_year
                        },
                        attributes
                    )
                )
                .then(() => {
                    this.loading = false
                })

                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'leaveManagementWorkseetDetail/exportExcel',
          Object.assign({}, this.model, {
            branch_id: this.branch_id,
            department_id: this.model.department_id,
            cycle_year: this.model.cycle_year

          })
        )
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
    }

}
</script>
<style scoped>
table>tbody>tr td {
    vertical-align: middle;
}

.table>thead>tr>th {
    border: 1px solid #b6c2c9;
    vertical-align: middle;
}

::-webkit-scrollbar {
    height: 8px;
    width: 3px;
    /* Remove scrollbar space */
    background: #ffff;
    /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
    background: #b7b7b8;
}

.color-green {
    background-color: rgb(0, 176, 80);
}

.color-title {
    color: white;
}

.color-yeallow {
    background-color: rgb(146, 208, 80);
}

.color-red {
    background-color: red;
}

.color-blue {
    background-color: rgb(0, 151, 254);
}

.color-orange {
    background-color: rgb(255, 192, 0);
}

.color-b {
    background-color: rgb(68, 114, 196);
}

.color-d {
    background-color: rgb(180, 198, 231);
}

.nowrap {
    white-space: nowrap;

}
</style>